import { useState } from "react";
import { Store, Pencil, Check, Loader2 } from "lucide-react";

const CURRENCIES = [
  { code: "EUR", symbol: "\u20ac", label: "EUR \u20ac" },
  { code: "XOF", symbol: "F CFA", label: "XOF F CFA" },
  { code: "USD", symbol: "$", label: "USD $" },
  { code: "GBP", symbol: "\u00a3", label: "GBP \u00a3" },
  { code: "GHS", symbol: "GH\u20b5", label: "GHS GH\u20b5" },
  { code: "MAD", symbol: "MAD", label: "MAD" },
];

export function SettingsBoutiqueInfo({ info, accent, isDark, onSave }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState({ ...info });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    await onSave(draft);
    setEditing(false);
    setSaving(false);
  };

  // Sync draft if info changes externally
  const handleStartEdit = () => {
    setDraft({ ...info });
    setEditing(true);
  };

  return (
    <div className="s-card" data-testid="boutique-info-section">
      <div className="s-card-header">
        <div className="s-card-title-row">
          <Store size={18} style={{ color: accent }} />
          <h2 className="s-card-title">Informations boutique</h2>
        </div>
        {!editing ? (
          <button className="s-outlined-btn" onClick={handleStartEdit} data-testid="edit-info-btn">
            <Pencil size={12} /> Modifier
          </button>
        ) : (
          <div style={{ display: 'flex', gap: '8px' }}>
            <button className="s-outlined-btn" onClick={() => { setDraft({ ...info }); setEditing(false); }}>Annuler</button>
            <button className="s-accent-btn" onClick={handleSave} disabled={saving} data-testid="save-info-btn">
              {saving ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />} Enregistrer
            </button>
          </div>
        )}
      </div>
      <div className="s-rows">
        {[
          { label: "Nom de la boutique *", key: "boutique_name", type: "text" },
          { label: "Numero de telephone *", key: "telephone", type: "tel" },
          { label: "Email de contact *", key: "emailContact", type: "email" },
          { label: "Adresse", key: "adresse", type: "text" },
        ].map((row) => (
          <div key={row.key} className="s-row">
            <span className="s-row-label">{row.label}</span>
            {editing ? (
              <input className="s-input" type={row.type} value={draft[row.key]} onChange={(e) => setDraft({ ...draft, [row.key]: e.target.value })} data-testid={`input-${row.key}`} />
            ) : (
              <span className="s-row-value">{info[row.key] || <span className="s-empty">Non renseigne</span>}</span>
            )}
          </div>
        ))}
        <div className="s-row">
          <span className="s-row-label">Devise</span>
          {editing ? (
            <select className="s-input s-select" value={draft.devise} onChange={(e) => setDraft({ ...draft, devise: e.target.value })} data-testid="input-devise">
              {CURRENCIES.map(c => <option key={c.code} value={c.code}>{c.label}</option>)}
            </select>
          ) : (
            <span className="s-row-value">{CURRENCIES.find(c => c.code === info.devise)?.label || info.devise}</span>
          )}
        </div>
      </div>
    </div>
  );
}
